import { InventoryAdjustReason } from '../../constants/inventory-adjust-reason.js';
const VARIANCE_EITHER_WAY = [
    InventoryAdjustReason.PRIOR_COUNT_WRONG,
    InventoryAdjustReason.UOM_ERROR,
    InventoryAdjustReason.UNEXPLAINED_ACCEPTED,
    InventoryAdjustReason.OTHER,
];
/**
 * ADD and SCRAP are entry-time lists: the person making the change already knows why. VARIANCE_UP
 * and VARIANCE_DOWN are close-out lists chosen later by whoever investigated the count, so they
 * name causes instead of restating which way the stock went.
 */
export const ADJUST_REASONS_BY_ACTION = {
    ADD: [InventoryAdjustReason.FOUND, InventoryAdjustReason.CORRECTION, InventoryAdjustReason.OTHER],
    SCRAP: [
        InventoryAdjustReason.DAMAGED,
        InventoryAdjustReason.FAILED_TESTING,
        InventoryAdjustReason.EXPIRED,
        InventoryAdjustReason.OTHER,
    ],
    VARIANCE_UP: [
        InventoryAdjustReason.UNRECORDED_PRODUCTION,
        InventoryAdjustReason.SCRAP_IN_ERROR,
        InventoryAdjustReason.RECEIPT_TO_WRONG_LOCATION,
        InventoryAdjustReason.RETURN_NOT_RECORDED,
        ...VARIANCE_EITHER_WAY,
    ],
    VARIANCE_DOWN: [
        InventoryAdjustReason.CONSUMPTION_NOT_RECORDED,
        InventoryAdjustReason.SHIPMENT_NOT_RECORDED,
        InventoryAdjustReason.DAMAGE_NOT_RECORDED,
        InventoryAdjustReason.MOVED_WITHOUT_RECORDING,
        InventoryAdjustReason.THEFT_OR_LOSS,
        ...VARIANCE_EITHER_WAY,
    ],
};
//# sourceMappingURL=adjust-reasons-by-action.js.map